<template>
  <div class="week-text tw-flex tw-flex-col tw-gap-4 tw-items-center">
    <h1
      v-if="!composite"
      class="tw-text-center question-title-v2 tw-mb-6"
    >
      {{ question.question }}
    </h1>

    <textarea
      id="textarea"
      v-model="answer"
      class="tw-bg-[#F2F2F2] tw-w-[420px] tw-border-0 tw-p-3 tw-rounded focus:tw-outline-none placeholder:tw-text-[#b8b8b8]"
      rows="6"
      placeholder="Share what's on your mind so your doctor can help."
    ></textarea>

    <div>
      <b-button
        variant="info"
        class="tw-mt-4 onboarding-btn"
        @click="submitAnswer"
      >
        Continue
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
    composite: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      answer: '',
    };
  },
  watch: {
    question: {
      handler() {
        this.answer = null;
        if (this.question?.answer) {
          this.answer = this.question.answer;
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.question?.answer) {
      this.answer = this.question.answer;
    }
  },
  methods: {
    submitAnswer() {
      if (this.answer == '' && !this.question?.allowempty) {
        this.$emit('alert', 'The text field cannot be empty');
      } else {
        this.$emit('submitAnswer', { id: this.question.id, answer: this.answer || '' });
      }
    },
  },
};
</script>

<style></style>
